// extracted by mini-css-extract-plugin
export default {"headerTitle":"addParser_headerTitle__wr5q0","page":"addParser_page__2w96h","header":"addParser_header__2ckjd","container":"addParser_container__2C+RJ"};